import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useDndPlaceholder } from './useDndPlaceholder.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "onDragEnd", "onDragStart", "onDragUpdate"];
var Context = /*#__PURE__*/React.createContext(null);
var DndContext = function DndContext(_ref) {
  var children = _ref.children,
    onDragEnd = _ref.onDragEnd,
    onDragStart = _ref.onDragStart,
    onDragUpdate = _ref.onDragUpdate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dragDataByItemId = React.useRef({});
  var dndPlaceholder = useDndPlaceholder();
  var handleDragStart = React.useCallback(function (event) {
    dndPlaceholder.calculateProps(event.draggableId, event.source);
    if (onDragStart) {
      onDragStart(event.source, dragDataByItemId.current[event.draggableId]);
    }
  }, [dndPlaceholder, onDragStart]);
  var handleDragUpdate = React.useCallback(function (event) {
    if (!event.destination) {
      dndPlaceholder.clearProps();
      return;
    }
    dndPlaceholder.calculateProps(event.draggableId, event.source, event.destination);
    if (onDragUpdate) {
      onDragUpdate(event.source, event.destination, dragDataByItemId.current[event.draggableId]);
    }
  }, [dndPlaceholder, onDragUpdate]);
  var handleDragEnd = React.useCallback(function (event) {
    dndPlaceholder.clearProps();
    if (!onDragEnd || !event.destination) {
      return;
    }
    onDragEnd(event.source, event.destination, dragDataByItemId.current[event.draggableId]);
  }, [dndPlaceholder, onDragEnd]);
  var context = React.useMemo(function () {
    return {
      onDragEnd: onDragEnd,
      placeholderProps: dndPlaceholder.props,
      setDragDataByItemId: function setDragDataByItemId(draggableId, data) {
        dragDataByItemId.current = _objectSpread(_objectSpread({}, dragDataByItemId.current), {}, _defineProperty({}, draggableId, data));
      }
    };
  }, [dndPlaceholder.props, onDragEnd]);
  return /*#__PURE__*/jsx(DragDropContext, _objectSpread(_objectSpread({}, rest), {}, {
    onDragStart: handleDragStart,
    onDragUpdate: handleDragUpdate,
    onDragEnd: handleDragEnd,
    children: /*#__PURE__*/jsx(Context.Provider, {
      value: context,
      children: children
    })
  }));
};
DndContext.displayName = "DndContext";
function useDndContext() {
  return React.useContext(Context);
}

export { DndContext, useDndContext };
